import { css } from 'emotion';

export const virtualizedListWrapper = css`
  position: relative;
`;

export const backToTopButton = css`
  && {
    position: absolute;
    bottom: 20px;
    right: 20px;
  }
`;
